import { useDispatch } from 'react-redux';
import Swal from './swal';
import { submitStage } from './roadiesSlice';

/** "Time: mm:ss" (left) and "Points: n" (right) — the timer / score boxes on every stage. */
export function TopBar({ time, points, children }) {
  return (
    <div className="rd-topbar">
      <div className="rd-timer">Time: {time}</div>
      <div className="rd-topbar-right">
        {children}
        <div className="rd-score">Points: <span>{points}</span></div>
      </div>
    </div>
  );
}

/**
 * The country title + subtitle block above each game.
 * - title    -> .squid-title (blue, capitalised)
 * - children -> .squid-sub-title (light grey description)
 * - highlight -> .squid-third-title (green, uppercase instruction)
 * - note      -> small white "(Select the correct option…)" line
 */
export function GameHead({ title, children, highlight, note }) {
  return (
    <div className="rd-gamehead">
      {title && <h2 className="rd-title">{title}</h2>}
      {children && <div className="rd-subtitle">{children}</div>}
      {highlight && <div className="rd-highlight">{highlight}</div>}
      {note && <div className="rd-note">{note}</div>}
    </div>
  );
}

/** A simple centered modal (the Bootstrap #rules / #hint modals of the PHP game). */
export function Modal({ title, onClose, children }) {
  return (
    <div className="rd-overlay" onClick={onClose}>
      <div className="rd-modal" onClick={(e) => e.stopPropagation()}>
        {title && <div className="rd-modal-head">{title}</div>}
        <div className="rd-modal-body">{children}</div>
        <div className="rd-modal-foot">
          <button type="button" className="rd-modal-close" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export function RotateNotice() {
  return <div className="rd-rotate">Please rotate your device for the best experience</div>;
}

/** Returns save(round, score, timer) -> the server state, or null (after telling the player) on failure. */
export function useSaveScore() {
  const dispatch = useDispatch();
  return async (round, score, timer, { quiet = false } = {}) => {
    const res = await dispatch(submitStage({ round, score, timer }));
    if (submitStage.rejected.match(res)) {
      if (!quiet) Swal.fire('', res.payload || 'Could not save your progress. Please try again.', 'error');
      else console.error('Score not saved:', res.payload);
      return null;
    }
    return res.payload;
  };
}
